export const SHOW_DEBUG_OVERLAY = "sonder.editor.showDebugOverlay";
export const CACHED_CONTENT = "sonder.editor.cachedContent";
